module.exports = __webpack_public_path__ + "img/caution_60px.9e531bd2.svg";